import { useAuthUser } from "~/composables/useAuthUser";

export const useAuth = () => {
  const authUser = useAuthUser();

  const setUser = (user: any) => {
    authUser.value = user;
  };

  // Вход только по e-mail
  const login = async (email: string, password: string, altcha?: string) => {
    const data: any = await $fetch("/auth/login", {
      method: "POST",
      body: {
        email,
        password,
        altcha,
      },
    });

    setUser(data.user);

    return authUser;
  };

  const logout = async () => {
    const data: any = await $fetch("/auth/logout", {
      method: "POST",
    });

    setUser(data.user);
  };

  const me = async () => {
    if (!authUser.value) {
      try {
        const data: any = await $fetch("/auth/me", {
          headers: useRequestHeaders(["cookie"]) as HeadersInit,
        });
        setUser(data.user);
      } catch (error) {
        // Нет валидной сессии — считаем пользователя неавторизованным
        setUser(null);
      }
    }

    return authUser;
  };

  return { login, logout, me };
};
